import { SelectableModel } from '../models/selectable/selectable.model';
import { SelectableStylingModel } from '../models/selectable/selectable-styling.model';

export const /** @type {?} */ CheckboxTemplates = {
  defaultTemplate: {
    property: new SelectableModel({
      display: true,
      disable: false,
      value: 'checkbox',
      item: 'Checkbox',
      checked: false,
      itemPosition: 'after'
    }),
    style: new SelectableStylingModel({
      container: {
        class: 'cf-default-container'
      },
      button: {
        themeColor: 'primary'
      }
    })
  }
}
